import { Component, OnInit } from '@angular/core';
import { NewSavingsAccountService, SavingsAccount, SavingsAccountState } from '@brightside-web/desktop/feature/savings-account';
import {Observable} from "rxjs";

@Component({
    selector: 'brightside-web-savings-account-statements',
    templateUrl: './savings-account-statements.component.html',
    styleUrls: ['./savings-account-statements.component.css'],
    standalone: false
})
export class SavingsAccountStatementsComponent implements OnInit {

  currentAccountInfo$: Observable<SavingsAccountState>  = this.savingsSvc.currentAccountInfo;

  constructor(
    private savingsSvc: NewSavingsAccountService,
  ) { }

  ngOnInit(): void {
    this.savingsSvc.getSavingsAccounts();
  }

}
